/* eslint class-methods-use-this: ["error", { "exceptMethods": ["onSubmit"] }] */
class MotionWrapper {
	constructor(element, delay, callback) {
		this.element = element;
		this.delay = delay || 0;
		this.offset = '200px';
		this.options = {
			rootMargin: `-${this.offset} 0px 0px 0px`,
		};
		this.observer = new IntersectionObserver((elements) => {
			const isInEditMode = document.body.classList.contains('editing-mode');
			elements.forEach((el) => {
				if (el.isIntersecting) {
					setTimeout(() => {
						this.element.classList.add('complete');

						if (callback) {
							callback();
						}
					}, isInEditMode ? 0 : this.delay);
				}
			});
		}, this.options);

		if (this.element) {
			this.observer.observe(this.element);
		}
	}
}

export default MotionWrapper;
